import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

export const Graph = (props) => {
  const { merchoidStock } = props;
  const [selectedOption, setSelectedOption] = useState('productBrand'); // Default option

  const formatData = (data, optionValue, qtyByDateKey, costKey) => {
    const dateToValueMap = new Map();

    const filteredData = optionValue !== 'All'
      ? data.filter(obj => obj[selectedOption] === optionValue)
      : data;

    filteredData.forEach(obj => {
      if (!obj[qtyByDateKey] || !obj[costKey]) {
        return;
      }
      obj[qtyByDateKey].forEach(([date, qty]) => {
        const roundedDate = new Date(date);
        roundedDate.setHours(0, 0, 0, 0); // Set time to 00:00:00 to allow aggregation by date

        const dateInMilliseconds = roundedDate.getTime();
        const currentValue = dateToValueMap.get(dateInMilliseconds) || 0;
        
        const newValue = currentValue + (qty * obj[costKey]);

        if (newValue >= 1000) {
          dateToValueMap.set(dateInMilliseconds, newValue);
        }
      });
    });

    const aggregatedData = Array.from(dateToValueMap).map(([date, value]) => {
      return { x: date, y: value };
    });

    // Sorting the data based on date
    aggregatedData.sort((a, b) => new Date(a.x) - new Date(b.x));

    return aggregatedData;
  };


  useEffect(() => {
    const uniqueOptions = [...new Set(merchoidStock.map(obj => obj[selectedOption]))];
    
    const newSeries = uniqueOptions.map(optionValue => {
      const stockData = formatData(merchoidStock, optionValue, 'qtyByDate', 'productCost');
      const aaaStockData = formatData(merchoidStock, optionValue, 'aaaQtyByDate', 'aaaCostPrice');
      
      // If 'All' is not selected, we combine the stock data
      let combinedData = [];
      if (selectedOption !== 'All') {
        combinedData = aggregateData(stockData, aaaStockData);
      }
      
      return [
        ... (selectedOption === 'All' 
          ? [
              { name: `${optionValue} Stock Value`, data: stockData },
              { name: `${optionValue} AAA Stock Value`, data: aaaStockData },
            ]
          : [
              { name: `${optionValue} Combined Stock Value`, data: combinedData },
            ]
        ),
      ];
    }).flat();  // Flatten the array of arrays into a single array
  
    setSeries(newSeries);
  }, [merchoidStock, selectedOption]);
  

  function aggregateData(data1, data2) {
    const map = new Map();

    [...data1, ...data2].forEach(({ x, y }) => {
      map.set(x, (map.get(x) || 0) + y);
    });

    return Array.from(map, ([x, y]) => ({ x, y }));
  }



  const [series, setSeries] = useState([{
    name: "Stock Quantity",
    data: formatData(merchoidStock),
  }]);

  const [options, setOptions] = useState({
    chart: {
      id: 'basic-bar',
    },
    xaxis: {
      type: 'datetime',
    },
    yaxis: {
      title: {
        text: 'Quantity',
      },
    },
    title: {
      text: 'Stock Movements Over Time',
      align: 'left',
    },
  });

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="app" style={{ width: '100vw', height: '100vh' }}>
      <div className="row" style={{ width: '100%', height: '100%' }}>
        <div className="mixed-chart" style={{ width: '100%', height: '100%' }}>
          <select onChange={handleOptionChange}>
            <option value="All">All</option>
            <option value="productBrand">Product Brand</option>
            <option value="productCategory">Product Category</option>
            <option value="supplierCode">Supplier Code</option>
          </select>
          <Chart
            options={options}
            series={series}
            type="line"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  );

}
